import { Card, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { MapPin, Tag, Clock, Flame, Calendar } from 'lucide-react';

const HERO_COLORS = [
  { from: 'from-red-600', to: 'to-red-500', btn: 'text-red-600' },
  { from: 'from-emerald-600', to: 'to-emerald-500', btn: 'text-emerald-600' },
  { from: 'from-orange-600', to: 'to-orange-500', btn: 'text-orange-600' },
  { from: 'from-blue-600', to: 'to-blue-500', btn: 'text-blue-600' },
];

const HERO_ICONS = {
  'Maior Desconto': Tag,
  'Mais Recente': Clock,
  'Mais Ativado': Flame,
  'Maior Validade': Calendar,
};

export const LandingHeroCarousel = ({ heroCoupons, heroIndex, setHeroIndex, onLogin }) => {
  if (heroCoupons.length === 0) return null;

  return (
    <section className="py-4 sm:py-8 md:py-12" data-testid="hero-carousel-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="relative">
          {heroCoupons.map((coupon, idx) => {
            const colors = HERO_COLORS[idx % HERO_COLORS.length];
            const HeroIcon = HERO_ICONS[coupon.hero_label] || Tag;
            return (
              <div key={coupon.coupon_id}
                className={`transition-all duration-500 ${idx === heroIndex ? 'opacity-100 relative' : 'opacity-0 absolute inset-0 pointer-events-none'}`}
                data-testid={`hero-slide-${idx}`}>
                <Card className={`bg-gradient-to-r ${colors.from} ${colors.to} border-0 shadow-xl overflow-hidden cursor-pointer hover:shadow-2xl transition-shadow`}
                  onClick={onLogin}>
                  <CardContent className="py-4 px-4 sm:py-8 sm:px-8 flex flex-row items-center gap-3 sm:gap-6">
                    {coupon.images?.length > 0 && (
                      <div className="w-24 h-24 sm:w-40 sm:h-40 rounded-lg sm:rounded-xl overflow-hidden border-2 sm:border-4 border-white/30 shrink-0">
                        <img src={coupon.images[0]} alt={coupon.title} className="w-full h-full object-cover" />
                      </div>
                    )}
                    <div className="flex-1 min-w-0">
                      <div className="flex items-center gap-2 mb-1 sm:mb-3">
                        <Badge className="bg-white/20 text-white border-white/30 text-xs sm:text-lg px-2 sm:px-4 py-0.5 sm:py-1">
                          {coupon.discount_percentage}% OFF
                        </Badge>
                        <Badge className="bg-white/10 text-white/90 border-white/20 text-[10px] sm:text-sm px-2 py-0.5 flex items-center gap-1">
                          <HeroIcon className="h-3 w-3" />
                          {coupon.hero_label}
                        </Badge>
                      </div>
                      <h2 className="text-sm sm:text-2xl md:text-3xl font-black text-white mb-0.5 sm:mb-2 truncate">{coupon.title}</h2>
                      <p className="text-white/80 text-xs sm:text-base mb-0.5 sm:mb-2 line-clamp-1 sm:line-clamp-2">{coupon.description}</p>
                      <div className="flex items-center gap-1 text-white/70 text-xs sm:text-sm">
                        <MapPin className="h-3 w-3 sm:h-4 sm:w-4" /> {coupon.city}, {coupon.state}
                      </div>
                      <Button className={`bg-white ${colors.btn} hover:bg-white/90 font-bold px-3 sm:px-8 py-1.5 sm:py-3 text-xs sm:text-lg rounded-md sm:rounded-lg shadow-md mt-1 sm:mt-2`}
                        data-testid={`hero-coupon-btn-${idx}`}>
                        Resgatar
                      </Button>
                    </div>
                  </CardContent>
                </Card>
              </div>
            );
          })}
          <div className="flex justify-center gap-2 mt-3" data-testid="hero-carousel-dots">
            {heroCoupons.map((c, i) => (
              <button key={`hero-dot-${c.coupon_id}`} onClick={() => setHeroIndex(i)}
                className={`h-2.5 rounded-full transition-all duration-300 ${i === heroIndex ? 'bg-slate-800 w-7' : 'bg-slate-300 w-2.5 hover:bg-slate-400'}`}
                data-testid={`hero-dot-${i}`} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
